
const escapeRegExp = (term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Filters an already loaded medication list by what has been typed into a dropdown.
 *
 * Used by the resident owned stock dropdowns, which fetch the whole holding once and so
 * have no server side search to fall back on. Matches the brand name and the generic name
 * so a generic search still finds stock held under a brand, and matches from the start of
 * a word like the backend drug search does.
 *
 * A non string search term means an option is selected rather than text typed, so the
 * full list comes back.
 */
export const filterMedicationList = (medList, searchTerm) => {
    if (!Array.isArray(medList)) {
        return [];
    }

    if (typeof searchTerm !== 'string') {
        return medList;
    }

    const terms = searchTerm.toLowerCase().split(' ').filter(term => term !== '');

    if (!terms.length) {
        return medList;
    }

    return medList.filter(med => {
        const alias = med.alias || {};
        // the label also carries the quantity, so match on the names only - otherwise
        // typing a number pulls up everything with that number in stock
        const names = `${alias.generic_name || ''} ${alias.name || ''} ${med.generic_name || ''} ${med.name || ''}`.toLowerCase();

        return terms.every(term => new RegExp(`\\b${escapeRegExp(term)}`).test(names));
    });
}
